// extracted by mini-css-extract-plugin
export default {"expander":"expander_expander__qmjpH","header":"expander_header__ls4H+","icon":"expander_icon__N9HU9","result":"expander_result__mlnV8","cardColor":"expander_cardColor__Qeh1L"};